"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Presentation = void 0;
var preact_1 = require("preact");
var Presentation = function () { return ((0, preact_1.h)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    (0, preact_1.h)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6 4C4.34315 4 3 5.34315 3 7V17C3 18.6569 4.34315 20 6 20H18C19.6569 20 21 18.6569 21 17V7C21 5.34315 19.6569 4 18 4H6ZM18 8H6V16H18V8Z", fill: "white" }))); };
exports.Presentation = Presentation;
//# sourceMappingURL=presentation.js.map